import React from "react"
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts"
import { AGING_BUCKETS, formatINR } from "../constants"

export default function AgingBucketChart({ buckets }) {
  if (!buckets?.length) return null

  const chartData = buckets.map((b) => {
    const config = AGING_BUCKETS.find((ab) => ab.key === b.key) || {}
    return {
      label: config.label || b.label,
      amount: b.amount,
      count: b.count,
      color: config.color || "#64748b",
    }
  })

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5">
      <h3 className="mb-4 text-[14px] font-medium text-slate-700">Aging Distribution</h3>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={chartData} layout="vertical" margin={{ left: 10, right: 30 }}>
          <XAxis type="number" tickFormatter={(v) => formatINR(v)} tick={{ fontSize: 11 }} />
          <YAxis
            type="category"
            dataKey="label"
            width={90}
            tick={{ fontSize: 12 }}
          />
          <Tooltip
            formatter={(value) => [formatINR(value), "Amount"]}
            labelStyle={{ fontSize: 12, fontWeight: 500 }}
            contentStyle={{ fontSize: 12, borderRadius: 8 }}
          />
          <Bar dataKey="amount" radius={[0, 4, 4, 0]} barSize={28}>
            {chartData.map((entry, idx) => (
              <Cell key={idx} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
